module.exports = __webpack_public_path__ + "img/7.5dc04dd5.jpg";